// extracted by mini-css-extract-plugin
module.exports = {"basket-button":"basket-button__3qoWe","border":"border__2u9Pd","wrapper":"wrapper__1nov5","countBadge":"countBadge__3O6CX"};